



































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ZenButton from '@reciprocity/button';

import { objectStatusColor } from '@/utils';
import setStatus from '../mixins/setStatus';

export default Vue.extend({
  name: 'ScopingItem',
  components: {
    ZenButton,
  },
  mixins: [setStatus],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['routes']),
    badgeClass() {
      return `badge badge-${objectStatusColor(this.item.status.value) || 'light'}`;
    },
    buttonConfig() {
      if (this.item.status.value === 'In Scope') {
        return { variant: 'error', text: 'Unscope', newStatus: 'Draft' };
      }
      return { variant: 'success', text: 'Scope', newStatus: 'In Scope' };
    },
    objectUrl() {
      return this.routes.sorInfo
        .replace('__OBJECT_TYPE__', this.item.__typename)
        .replace('__OBJECT_ID__', this.item.dbId)
        .replace('__TAB__', 'info');
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    async setItemStatus(newStatus: 'In Scope' | 'Draft') {
      try {
        this.loading = true;
        await this.setStatus(newStatus, this.item.id, this.item.__typename);
      } catch {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      } finally {
        this.loading = false;
      }
    },
  },
});
